module.exports = __webpack_public_path__ + "img/cambio.316d1ef8.gif";